import useGlobalEvents from "../hooks/useGlobalEvents";

const AppWrapper: React.FC<{ children: any }> = ({ children }) => {
  //   useGlobalEvents();
  return children;
};
export default AppWrapper;
